import React from 'react';
import AppLayout from './components/AppLayout';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import MiniFooter from './components/MiniFooter';
import ScrollToTop from './components/ScrollToTop';
import AppRoutes from './pages/Routes';
import Providers from './providers';

import './App.scss';

const App: React.FunctionComponent = () => {
  return (
    <Providers>
      <AppLayout
        header={<Header />}
        content={
          <ScrollToTop>
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
          </ScrollToTop>
        }
        footer={<MiniFooter />}
      />
    </Providers>
  );
};

export default App;
